export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10587.efbd8d4c.jpg";